import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseLink } from "../../../../models/base-link";
import { Registration } from "../../../../models/registration";
import { Service } from "../../../../models/service";
import { CostControllerService } from "../../../../services/cost-controller/cost-controller.service";
// for totals models
import { InstitutionControllerService } from "../../../../services/institution-controller/institution-controller.service";
import { LawControllerService } from "../../../../services/laws-controller/law-controller.service";
import { ServiceLocationControllerService } from "../../../../services/location-controller/service-location-controller.service";
import { MessageControllerService } from "../../../../services/message-controller/message-controller.service";
import { NotificationControllerService } from "../../../../services/message-controller/notification-controller.service";
import { DeterminantControllerService } from "../../../../services/registration-controller/determinant-controller.service";
import { RequirementControllerService } from "../../../../services/requirement-controller/requirement-controller.service";
import { DocumentResultControllerService } from "../../../../services/result-controller/document-result-controller.service";
import { RegistrationControllerService } from "../../../../services/registration-controller/registration-controller.service";
import { ServiceControllerService } from "../../../../services/service-controller/service-controller.service";
import { FormControllerService } from "../../../../services/form-controller/form-controller.service";

@Component({
    selector: "app-tables-base",
    templateUrl: "./tables-base.component.html",
    styleUrls: ["./tables-base.component.scss"],
    providers: [
        DeterminantControllerService,
        RequirementControllerService,
        DocumentResultControllerService,
        RegistrationControllerService,
        ServiceControllerService,
        CostControllerService,
        InstitutionControllerService,
        MessageControllerService,
        NotificationControllerService,
        LawControllerService,
        ServiceLocationControllerService,
        FormControllerService,
    ],
})
export class TablesBaseComponent implements OnInit {

    // items list
    public items: BaseLink[];
    public serviceId: string;
    public observables: any[];
    public documentResults: any[] = [];
    public allRegistrations: Registration[];

    // fix for costs
    public costs = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private registrationDeterminantControllerService: DeterminantControllerService,
                private requirementControllerService: RequirementControllerService,
                private documentResultControllerService: DocumentResultControllerService,
                private serviceController: ServiceControllerService,
                private costControllerService: CostControllerService,
                private institutionControllerService: InstitutionControllerService,
                private messageControllerService: MessageControllerService,
                private lawControllerService: LawControllerService,
                private serviceLocationControllerService: ServiceLocationControllerService,
                private formControllerService: FormControllerService,
    ) { }

    public ngOnInit() {

        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
        });
        // init items list
        this.getItemsList();
    }

    private getItemsList(): void {
        this.items = [
            new BaseLink("All form fields", `/services/${this.serviceId}/fieldstable`, this.formControllerService.getFilteredFormFields(this.serviceId, null, false, false, false, false, false, true, true)),
            new BaseLink("nav.annexes-determinants", `/services/${this.serviceId}/determinantstable`, this.registrationDeterminantControllerService.getAllDeterminants(this.serviceId, false)),
            new BaseLink("nav.annexes.results", `/services/${this.serviceId}/resultstable`, this.documentResultControllerService.getAllResults(this.serviceId)),
            new BaseLink("nav.annexes.documents", `/services/${this.serviceId}/documentstable`, this.requirementControllerService.getServiceRequirements()),
            new BaseLink("nav.annexes.costs", `/services/${this.serviceId}/coststable`),
            new BaseLink("nav.annexes.inst", `/services/${this.serviceId}/institutionstable`, this.institutionControllerService.getInstitutions()),
            new BaseLink("Templates", `/services/${this.serviceId}/templates`),
            new BaseLink("nav.annexes.laws", `/services/${this.serviceId}/lawstable`, this.lawControllerService.getLawsList()),
            new BaseLink("nav.annexes.collection-place", `/services/${this.serviceId}/locationstable`, this.serviceLocationControllerService.getServiceLocations(this.serviceId)),
        ];

        // for costs
        this.setCostsItemLabel(this.items[4]);
        // for units
        this.setUnitsItemLabel(this.items[6]);
        // for messages
        this.setMessagesLabel(this.items[6]);
    }

    public setMessagesLabel(item: BaseLink): void {
        this.messageControllerService.getMessagesListByPage(0, 0, "", "", "", null).subscribe(
            (data) => {
                item.setLabel(data.totalElements);
            },
        );
    }

    public setCostsItemLabel(item: BaseLink): void {
        this.serviceController.getService(this.serviceId).subscribe(
            (data: Service) => {
                if (data && data.registrations) {
                    this.costs = [];
                    console.log(data);
                    data.registrations.forEach((reg: Registration) => {
                        this.costControllerService.getRegistrationCostList(reg.id).subscribe(
                            (data1) => {
                                this.costs = this.costs.concat(data1);
                                item.setLabel(this.costs.length.toString());
                            },
                        );
                    });
                }

            });
    }

    public setUnitsItemLabel(item: BaseLink): void {
        this.institutionControllerService.getAllInstitutionsAndUnits().subscribe(
            (data) => {
                const unitsLength = [].concat(...data.map((institution) => institution.units)).length;
                item.setLabel(unitsLength.toString());
            },
        );
    }
}
